import makeStyles from '@material-ui/core/styles/makeStyles';

type Props = {
  activeTabColor?: string;
};

export const useStyles = makeStyles(theme => ({
  tabsContainer: {
    borderBottom: `2px solid ${theme.palette.grey['50']}`,
    width: 'fit-content',
  },
  tabRoot: {
    minWidth: 'unset',
    textTransform: 'unset',
    letterSpacing: '0px',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '25px',
    color: theme.palette.grey['400'],
    padding: '13px 22px',

    '&.Mui-selected': {
      color: ({ activeTabColor = theme.palette.primary.main }: Props) => activeTabColor,
    },
  },
  tabsIndicator: {
    backgroundColor: ({ activeTabColor = theme.palette.primary.main }: Props) => activeTabColor,
  },
}));
